var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"ml-1 whitespace-normal",attrs:{"pill":"","variant":_vm.selectedPromo.promo_type === 'free_product'
      ? 'light-success'
      : _vm.selectedPromo.promo_type === 'price_discount'
      ? 'light-warning'
      : 'primary'}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }